<template>
  <a-card :bordered="false">
    <custom-page-table
      style="margin-top: 16px;"
      ref="table"
      :queryParams="queryParams"
      :columns="columns"
      base-key="serviceUrl"
      query-path="inform/getInformTemplateList"
    >
      <span slot="action" slot-scope="rowItem">
        <a @click="edit(rowItem.record)">编辑</a>
      </span>
    </custom-page-table>
    <a-modal title="编辑模板通知" :width="900" :footer="null" :visible="visible" @cancel="handleCancel">
      <a-form-model ref="ruleForm" :model="editDatalist" :rules='editRules' :label-col="labelCol"
                    :wrapper-col="wrapperCol">
        <a-form-model-item label="通知类型">
          <span v-if="editDatalist.templateType == '站内信'">站内信</span>
          <span v-if="editDatalist.templateType == '模板消息'">模板消息</span>
        </a-form-model-item>
        <a-form-model-item label="支持终端">
          <a-checkbox-group v-model="editDatalist.templateTerminal">
            <a-checkbox value="1" disabled>小程序</a-checkbox>
            <a-checkbox value="2" disabled>公众号</a-checkbox>
            <a-checkbox value="3" disabled>H5商城</a-checkbox>
          </a-checkbox-group>
        </a-form-model-item>
        <a-form-model-item label="触发方式">
          <span>{{ editDatalist.templateTouch }}</span>
        </a-form-model-item>
        <a-form-model-item label="接收人">
          <span>{{ editDatalist.recType }}</span>
        </a-form-model-item>
        <a-form-model-item v-if="editDatalist.templateType == '模板消息'" label="模板编号">
          <span>{{ editDatalist.templateNumber }}</span>
          <span style="margin-left:50px;color:red">微信模板编号需在公众号及小程序后台添加</span>
        </a-form-model-item>
        <a-form-model-item label="通知标题">
          <span>{{ editDatalist.templateTitle }}</span>
        </a-form-model-item>
        <a-form-model-item :wrapper-col="{ span: 14, offset: 4 }" v-if="editDatalist.templateType == '站内信'">
          <a-row :gutter="8">
            <a-col :span="1" style="width:80px;height:80px;">
              <img :src="editDatalist.templateExampleContentList[0]" alt="" style="width:80px;height:80px;"/>
            </a-col>
            <a-col :span="14" style="margin-left:20px">
              <div style="margin-bottom:0px;margin-left:80px">
                <span style="display:inline-block;width:250px;line-height:30px;margin-left:-80px">{{
                    editDatalist.templateExampleContentList[1]
                  }}</span>
              </div>
              <div style="position:relative;line-height:20px">{{ editDatalist.templateExampleContentList[2] }}</div>
            </a-col>
          </a-row>
        </a-form-model-item>
        <div v-if="editDatalist.templateType == '模板消息'">
          <a-form-model-item
            :wrapper-col="{ span: 14, offset: 4 }"
            v-for="(item, index) in editDatalist.templateExampleContentList"
            :key="index"
          >
            <span>{{ item }}</span>
          </a-form-model-item>
        </div>
        <a-form-model-item label="状态">
          <a-radio-group v-model="editDatalist.status">
            <a-radio :value="1">开启</a-radio>
            <a-radio :value="0">关闭</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item
          v-if="editDatalist.templateTerminal<3"
          :label="editDatalist.templateTerminal==1?'小程序模版ID':'公众号模版ID'"
          prop="appletId"
        >
          <a-input v-model="editDatalist.appletId"></a-input>
        </a-form-model-item>
        <a-form-model-item :wrapper-col="{ span: 14, offset: 4 }">
          <a-button type="primary" @click="savebtn">保存设置</a-button>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </a-card>
</template>

<script>
export default {
  name: 'NoticTemplate',
  data() {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 20 },
      queryParams: {
        merchantId: this.$store.getters.userInfo.merchantId,
        platformId: this.getPlatformConfig().platformId
      },
      merchantId: this.$store.getters.userInfo.merchantId,
      platformId: this.getPlatformConfig().platformId,
      editDatalist: {},
      editRules: {
        appletId: [
          { required: true, message: '请输入模版ID', trigger: 'blur' }
        ]
      },
      id: '',
      visible: false,
      columns: [
        {
          title: 'ID',
          dataIndex: 'id'
        },
        {
          title: '通知标题',
          dataIndex: 'templateTitle'
        },
        {
          title: '类型',
          dataIndex: 'templateType'
        },
        {
          title: '支持终端',
          dataIndex: 'templateTerminal'
        },
        {
          title: '接收人',
          dataIndex: 'recType'
        },
        {
          title: '状态',
          dataIndex: 'status'
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    }
  },
  mounted() {
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'MessageNotificationList', title: '通知记录' },
      { name: 'NoticTemplate', title: '通知模板' }
    ])
  },
  methods: {
    edit(record) {
      this.visible = true
      this.id = record.id
      this.getData()
    },
    getData() {
      this.getHttpServices()
        .getServerApiService()
        .post(
          'inform/getInformTemplate?id=' + this.id + '&merchantId=' + this.merchantId + '&platformId=' + this.platformId
        )
        .then(res => {
          this.editDatalist = res
          this.editDatalist.templateTerminal = this.editDatalist.templateTerminal.split(',')
          this.getLogUtils().logWithTag('this.editDatalist', this.editDatalist)
        })
        .catch(err => {
        })
    },
    // 编辑模板信息按钮
    savebtn() {
      this.$refs['ruleForm'].validate(valid => {
        if (valid) {
          this.saveRequest()
        } else {
          this.$message.error('请完善表单信息')
        }
      })

    },
    saveRequest() {
      let GetInformMerchantTemplateDto = {
        id: this.editDatalist.id,
        merchantId: this.merchantId,
        status: this.editDatalist.status,
        appletId: this.editDatalist.appletId
      }
      this.getHttpServices()
        .getServerApiService()
        .post('inform/updateInformTemplate', GetInformMerchantTemplateDto)
        .then(res => {
          this.$message.success('保存成功')
          this.visible = false
          this.$refs.table.refresh()
        })
        .catch(err => {
          this.$message.success(err.msg)
          this.visible = false
        })
    },
    handleCancel() {
      this.visible = false
    }
  }
}
</script>
<style scoped></style>
